"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterOverlay = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Button"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _resetFilters = require("../../utils/resetFilters");

/**
 * Filter overlay component for mobile/tablet view
 * Displays advanced search filters in a modal-like overlay
 */
var FilterOverlay = function FilterOverlay(_ref) {
  var onClose = _ref.onClose;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('instant-search__results-wrapper', 'is-hidden-L')
  }, (0, _preact.h)("div", {
    className: "instant-search__results-wrapper-filter"
  }, (0, _preact.h)("div", {
    className: "instant-search__results-wrapper-filter-header"
  }, (0, _preact.h)(_Close.default, {
    onClick: onClose,
    role: "button",
    tabIndex: 0,
    "aria-label": "Close filters",
    style: {
      cursor: 'pointer'
    }
  }), (0, _preact.h)("h3", {
    className: "instant-search__results-wrapper-filter-header-heading"
  }, (0, _preact.h)(_phrase.default, {
    p: "advanced.search.filters"
  })), (0, _preact.h)("button", {
    onClick: _resetFilters.resetFilters,
    className: "instant-search__results-wrapper-filter-header-btn"
  }, (0, _preact.h)(_phrase.default, {
    m: "Common",
    p: "advanced.search.filter.clear.all"
  }))), (0, _preact.h)("div", {
    className: "instant-search__results-wrapper-filters"
  }), (0, _preact.h)("div", {
    className: "instant-search__results-wrapper-filter-show-more-wrapper"
  }, (0, _preact.h)(_Button.default, {
    cta: true,
    className: "instant-search__results-wrapper-filter-show-more",
    onClick: onClose
  }, (0, _preact.h)(_phrase.default, {
    p: "show.results"
  })))));
};

exports.FilterOverlay = FilterOverlay;